import { render, staticRenderFns } from "./workitem-detail.vue?vue&type=template&id=6f94c3ec"
import script from "./workitem-detail.vue?vue&type=script&lang=ts"
export * from "./workitem-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports